<template>
  <modal
      :show="showModal"
      :show-action-btn="true"
      :action-text="__('mistakes.mark_as_learned')"
      :btn-class="'btn-primary'"
      @close="$emit('close')"
      @action-clicked="markMistakeAsLearned">

    <div v-if="question" class="p-4 sm:text-left">
      <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">Details zur Prüfungsfrage</h3>
      <div class="mt-2">
        <p class="text-sm text-gray-500"></p>
        <table class="w-full text-sm text-left text-gray-500">
          <tbody>
          <tr class="bg-white border-b">
            <th scope="row" class="p-4 text-xs text-gray-700 uppercase bg-gray-50">
              Frage:
            </th>
            <td class="py-4 px-6">
              {{ question.text }}
            </td>
          </tr>
          <tr class="bg-white border-b">
            <th scope="row" class="p-4 text-xs text-gray-700 uppercase bg-gray-50">
              Deine Antwort:
            </th>
            <td class="py-4 px-6" v-html="getUserAnswerText()"></td>
          </tr>
          <tr class="bg-white border-b">
            <th scope="row" class="p-4 text-xs text-gray-700 uppercase bg-gray-50">
              Richtig beantwortet?
            </th>
            <td class="py-4 px-6">
              {{ getIfRight }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../Modal'

export default {

  name: 'MistakeModal',

  components: {
    Modal,
  },

  props: {
    question: {
      type: Object,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  emits: ['close', 'mistake-learned'],

  computed: {
    getIfRight() {
      return ( this.question.isCorrect ) ? this.__('general.right') : this.__('general.wrong')
    },
  },

  methods: {

    markMistakeAsLearned: function() {
      this.$emit('mistake-learned', this.question )
      this.$emit('close')
    },

    getUserAnswerText: function () {
      let answerText = ''
      if (this.question.type === 1) {
        this.question.choices.map(choice => {
          if (choice.id === this.question.answers) {
            answerText += choice.text
          }
        })
      }
      if (this.question.type === 2) {
        this.question.choices.map(choice => {
          this.question.answers.map(answerId => {
            if (choice.id === answerId) {
              answerText += choice.text + '<br>'
            }
          })
        })
      }
      if (this.question.type === 3) {
        answerText += this.question.answers
      }
      // this.map( question.answers )

      return answerText
    },
  },
}
</script>

<style scoped>

</style>